module.exports = __webpack_public_path__ + "img/help7.5177304e.png";